import { render, staticRenderFns } from "./ConfirmBankPaymentPage.vue?vue&type=template&id=65a9c500&scoped=true"
import script from "./ConfirmBankPaymentPage.vue?vue&type=script&lang=js"
export * from "./ConfirmBankPaymentPage.vue?vue&type=script&lang=js"
import style0 from "./ConfirmBankPaymentPage.vue?vue&type=style&index=0&id=65a9c500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a9c500",
  null
  
)

export default component.exports